module.exports = __webpack_public_path__ + "static/maison-c5440ef4967a48d0a7c60c3ac97c38f0.jpg";